export default __webpack_public_path__ + "static/media/Abouticon.d1a418ec.svg";